import * as React from 'react';

/**
 * Focuses the referenced element exactly once, the first time `isReady`
 * becomes true. Useful for composers and other inputs that should grab focus
 * when they first become usable, without stealing focus on later state
 * transitions.
 */
export const useFocusOnceWhenReady = (ref: React.RefObject<HTMLElement | null>, isReady: boolean): void => {
  const hasFocusedRef = React.useRef(false);

  React.useEffect(() => {
    if (hasFocusedRef.current) return;
    if (isReady) {
      hasFocusedRef.current = true;
      ref.current?.focus();
    }
  }, [ref, isReady]);
};

export default useFocusOnceWhenReady;
